export const buildInsuranceAddPaxRequest = ({
    clientCode,
    key,
    referenceNo,
    userName,
    contactDetails,
    travellerData,
    riders,
}) => {
    debugger;
    const allTravellers = [
        ...(travellerData?.map((pax, index) => ({
            title: pax.title || "Mr.",
            firstName: pax.firstName,
            lastName: pax.lastName,
            passport: pax.passportNo || "",
            dob: pax.dob,
            address: pax.address || "",
            mobileNo: pax.mobileNo || "",
            email: pax.email || "",
            city: pax.city || "",
            district: pax.district || "",
            state: pax.state || "",
            pincode: pax.pincode || "",
            country: pax.country || "",
            preExistingMedicalCondition: pax.medicalCondition || "",
            finalPremium: Number(riders?.[0]?.ageWisePremiums?.[index]?.premium || 0),
            //riderTotalAmt: Number(pax.riderTotalAmt || 0),
            riderTotalAmt: riders?.reduce(
                (sum, rider) =>
                    sum + Number(rider?.ageWisePremiums?.[index]?.riderPremium || 0),
                0
            ) || 0,
            age: Number(pax.age || 0),
            //gender: pax.gender || "",
            gender: pax.title === "Mr" ? "Male" : pax.title === "Mrs" || pax.title === "Miss" ? "Female" : "",
            nominee: pax.nominee || "",
            relation: pax.relationship || "",
            pastillness: pax?.pastillness ?? "",
            remarks: pax?.remarks ?? "",
            crReferenceNumber: pax?.crReferenceNumber ?? "",
            emergencyContactPerson: pax?.emergencyContactPerson ?? "",
            emergencyContactNumber: pax?.emergencyContactNumber ?? "",
            emergencyEmailId: pax?.emergencyEmailId ?? "",
            gstNumber: contactDetails?.gstNumber ?? "",
            pnrNumber: pax?.pnrNumber ?? "",
            gstState: contactDetails?.state ?? "",
            univercityAddress: pax?.univercityAddress ?? "",
            univercityName: pax?.univercityName ?? "",
            flightNumber: pax?.flightNumber ?? "",
            departureTime: pax?.departureTime ?? "",
            arrivalTime: pax?.arrivalTime ?? "",
            departureAirportCode: pax?.departureAirportCode ?? "",
            arrivalAirportCode: pax?.arrivalAirportCode ?? "",
        })) || []),
    ];

    return {
        key,
        clientCode,
        userName,
        referenceNo,
        traveler: allTravellers,
        riders:
            riders?.map((rider) => ({
                riderId: rider.riderId,
                percent: Number(rider.premiumPercent || 0),
                riderName: rider.riderName || "",
                rateType: rider.riderRateType || "",
                riderAmount: Number(rider.riderValue || 0),
                totalAmount: Number(rider.premiumAmount || 0),
            })) || [],

        contactDetail: {
            emailId: contactDetails?.emailId || "",
            mobileNo: contactDetails?.mobile || ""
        },
        gstDetails: {
            clientCode: clientCode,
            key: key,
            referenceNo: referenceNo,
            gstNumber: contactDetails?.gstNumber || "",
            name: contactDetails?.gstName || "",
            email: contactDetails?.emailOngst || "",
            address: contactDetails?.addressOnGst || "",
            contactNo: contactDetails?.phoneOnGst || "",
        }

    };

};